import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppCommonModule } from '@common/common.module';
import { PlatformModule } from '@app/platform.module';
import { CompletedTasksView } from './views/completed-tasks/completed-tasks.view';
import { CompletedTasksRouterModule } from './completed-tasks.routes';
import { EmployeesCommonModule } from '@employees/employees.common.module';

@NgModule({
    declarations: [CompletedTasksView],
    imports: [CommonModule, CompletedTasksRouterModule, EmployeesCommonModule, AppCommonModule, PlatformModule],
})
export class CompletedTasksModule {}
